/**
 * opora-bid-paste-import.js
 * Bid Drafter paste → structured fields (heuristics only, no LLM).
 * Exposes window.OporaBidPasteImport
 */
(function (w) {
  'use strict';

  var SAMPLE_TEMPLATE =
    'Company Name: Apex Building Services\n' +
    'Prospect / Client: Piedmont Office Partners\n' +
    'Facility Name: Tower Two — Suite 400\n' +
    'Facility Contact: Jordan Lee, FM\n' +
    'Square Footage: 12,000\n' +
    'City: Buford\n' +
    'State: GA\n' +
    'Building Type: Commercial / Office\n' +
    'Frequency: 5 days/week\n' +
    'Hard Surface %: 70\n' +
    'Carpet %: 30\n' +
    'Restroom Fixtures: 24\n' +
    'Credentials: Licensed, Bonded, Insured\n' +
    'GL Per Occurrence: $1,000,000\n' +
    'GL Aggregate: $2,000,000\n' +
    'Notes: Nightly trash, restrooms, and common areas. Hard floors waxed quarterly.';

  var FIELD_LABELS = {
    'bd-company': 'Company Name',
    'bd-sqft': 'Square Footage',
    'bd-prospect': 'Prospect / Client',
    'bd-facility': 'Facility Name',
    'bd-contact': 'Facility Contact',
    'bd-city': 'City',
    'bd-state': 'State',
    'bd-frequency': 'Service Schedule',
    'bd-building': 'Building Type',
    'bd-hard-pct': 'Hard Surface %',
    'bd-carpet-pct': 'Carpet %',
    'bd-fixtures': 'Restroom Fixtures',
    'bd-years': 'Years in Business',
    'bd-gl-occurrence': 'GL Per Occurrence',
    'bd-gl-aggregate': 'GL Aggregate'
  };

  var CRITICAL = ['bd-company', 'bd-sqft', 'bd-city', 'bd-state'];

  function cleanVal(v) {
    return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().replace(/[.,;]+$/, '').trim();
  }

  function lineVal(text, patterns) {
    var raw = String(text || '');
    for (var i = 0; i < patterns.length; i++) {
      var m = raw.match(patterns[i]);
      if (m && m[1]) {
        var v = cleanVal(m[1]);
        if (v) return v;
      }
    }
    return '';
  }

  function parseNumber(raw) {
    if (raw == null || raw === '') return null;
    var n = Number(String(raw).replace(/[$,\s]/g, '').replace(/sq\.?\s*ft\.?/i, ''));
    return isNaN(n) ? null : n;
  }

  function mapFrequency(raw) {
    var s = String(raw || '').toLowerCase();
    if (!s) return '';
    if (/7\s*day|daily\s*7|sun.?sat|every\s*day/.test(s)) return 'daily_7';
    if (/5\s*day|mon.?fri|weekday|daily(?!\s*7)/.test(s)) return 'daily';
    if (/3\s*[x×]|three\s*day|m\/w\/f|mwf/.test(s)) return '3x_week';
    if (/bi.?week|every\s*other/.test(s)) return 'biweekly';
    if (/one.?time|deep\s*clean|single/.test(s)) return 'one_time';
    if (/month/.test(s)) return 'monthly';
    if (/week|1\s*day/.test(s)) return 'weekly';
    return '';
  }

  function mapBuilding(raw) {
    var s = String(raw || '').toLowerCase();
    if (!s) return '';
    if (/medical|health|hospital|clinic/.test(s)) return 'medical';
    if (/school|educat|k-?12|university|campus/.test(s)) return 'education';
    if (/industrial|warehouse|plant|factory/.test(s)) return 'industrial';
    if (/retail|restaurant|store|mall/.test(s)) return 'retail';
    if (/government|municipal|city hall|federal|county/.test(s)) return 'government';
    if (/office|commercial|corporate/.test(s)) return 'commercial';
    return '';
  }

  function parseCityState(text) {
    var out = { city: '', state: '' };
    var raw = String(text || '');
    out.city = lineVal(raw, [
      /^\s*city\s*[:\-–—]\s*(.+)$/im
    ]);
    out.state = lineVal(raw, [
      /^\s*state\s*[:\-–—]\s*([A-Za-z]{2}|[A-Za-z .]+)$/im
    ]);

    // Prefer tight "City, ST" / "in City, ST" before greedy location lines
    if (!out.city || !out.state) {
      var m =
        raw.match(/\bin\s+([A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)?),\s*([A-Z]{2})\b/) ||
        raw.match(/\b([A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)?),\s*([A-Z]{2})\b/) ||
        raw.match(/\b([A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)?)\s+([A-Z]{2})\b/);
      if (m) {
        if (!out.city) out.city = cleanVal(m[1]);
        if (!out.state) out.state = m[2];
      }
    }

    if (!out.city) {
      var locLine = lineVal(raw, [
        /^\s*(?:job\s+)?(?:site|address|location)\s*[:\-–—]\s*(.+)$/im
      ]);
      if (locLine) {
        var lm = locLine.match(/\b([A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)?),\s*([A-Z]{2})\b/) ||
          locLine.match(/^([A-Za-z .]+?),\s*([A-Z]{2})\b/);
        if (lm) {
          out.city = cleanVal(lm[1]);
          if (!out.state) out.state = lm[2];
        }
      }
    }

    // Reject overlong "city" captures (bad greedy matches)
    if (out.city && (out.city.split(' ').length > 4 || out.city.length > 40)) {
      var tail = out.city.split(/\s+/).slice(-2).join(' ');
      if (/^[A-Z]/.test(tail)) out.city = tail;
      else out.city = '';
    }

    if (out.state && out.state.length > 2) {
      var STATE_MAP = {
        georgia: 'GA', alabama: 'AL', florida: 'FL', texas: 'TX', california: 'CA',
        'new york': 'NY', 'north carolina': 'NC', 'south carolina': 'SC', tennessee: 'TN',
        virginia: 'VA', ohio: 'OH', illinois: 'IL', pennsylvania: 'PA', michigan: 'MI'
      };
      var key = out.state.toLowerCase();
      if (STATE_MAP[key]) out.state = STATE_MAP[key];
      else if (/^[A-Za-z]{2}$/.test(out.state)) out.state = out.state.toUpperCase();
    } else if (out.state) {
      out.state = out.state.toUpperCase();
    }
    return out;
  }

  function parseSqftLoose(text) {
    var labeled = lineVal(text, [
      /^\s*(?:square\s*footage|sq\.?\s*ft\.?|sqft|size)\s*[:\-–—]\s*(.+)$/im
    ]);
    var n = parseNumber(labeled);
    if (n && n >= 100) return Math.round(n);
    if (labeled) {
      var kLab = String(labeled).match(/^\s*([\d,.]+)\s*k\s*$/i);
      if (kLab) {
        n = parseNumber(kLab[1]);
        if (n) return Math.round(n * 1000);
      }
    }
    var m = String(text).match(/\b([\d,]{3,7})\s*(?:sq\.?\s*ft\.?|sqft|square\s*feet)\b/i);
    if (m) {
      n = parseNumber(m[1]);
      if (n && n >= 100) return Math.round(n);
    }
    var k = String(text).match(/\b([\d,.]+)\s*k\s*(?:sq\.?\s*ft\.?|sqft|square\s*feet)?\b/i);
    if (k) {
      n = parseNumber(k[1]);
      if (n && n * 1000 >= 100) return Math.round(n * 1000);
    }
    return null;
  }

  function parseFloorMix(text) {
    var hard = parseNumber(lineVal(text, [
      /^\s*hard\s*(?:surface|floor)?\s*%?\s*[:\-–—]\s*(.+)$/im,
      /\bhard\s*(?:surface|floor)?\s*[:=]?\s*(\d{1,3})\s*%/i
    ]));
    var carpet = parseNumber(lineVal(text, [
      /^\s*carpet\s*%?\s*[:\-–—]\s*(.+)$/im,
      /\bcarpet\s*[:=]?\s*(\d{1,3})\s*%/i
    ]));
    var mix = String(text).match(/\b(\d{1,3})\s*[\/:]\s*(\d{1,3})\s*(?:hard\s*\/\s*carpet|floor)/i);
    if (mix) {
      hard = parseNumber(mix[1]);
      carpet = parseNumber(mix[2]);
    }
    if (hard == null && carpet == null) return null;
    if (hard != null && carpet == null) carpet = Math.max(0, 100 - hard);
    if (carpet != null && hard == null) hard = Math.max(0, 100 - carpet);
    hard = Math.max(0, Math.min(100, Math.round(hard)));
    carpet = Math.max(0, Math.min(100, Math.round(carpet)));
    return { hard: hard, carpet: carpet };
  }

  function parseCredentials(text) {
    var out = { licensed: false, bonded: false, insured: false, certs: [] };
    var blob = String(text || '');
    var line = lineVal(blob, [
      /^\s*credentials?\s*[:\-–—]\s*(.+)$/im,
      /^\s*certifications?\s*[:\-–—]\s*(.+)$/im
    ]);
    var scan = (line || blob).toLowerCase();
    if (/\blicensed\b/.test(scan)) out.licensed = true;
    if (/\bbonded\b/.test(scan)) out.bonded = true;
    if (/\binsured\b/.test(scan)) out.insured = true;
    ['WBE', 'MBE', 'DBE', 'SBE'].forEach(function (c) {
      if (new RegExp('\\b' + c + '\\b', 'i').test(line || blob)) out.certs.push(c);
    });
    return out;
  }

  /**
   * @returns {{ fields: Object, extracted: string[], missingCritical: string[], defaultsApplied: string[], leftovers: string }}
   */
  function parse(text) {
    var raw = String(text || '');
    var fields = {};
    var extracted = [];
    var defaultsApplied = [];

    function take(key, val) {
      if (val == null || val === '') return;
      fields[key] = typeof val === 'number' ? String(val) : String(val);
      if (extracted.indexOf(key) < 0) extracted.push(key);
    }

    var company = lineVal(raw, [
      /^\s*(?:your\s+)?company\s*name\s*[:\-–—]\s*(.+)$/im,
      /^\s*business\s*name\s*[:\-–—]\s*(.+)$/im,
      /^\s*contractor\s*(?:name)?\s*[:\-–—]\s*(.+)$/im,
      /^\s*company\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-company', company);

    var prospect = lineVal(raw, [
      /^\s*(?:prospect|client|customer)\s*(?:\/\s*client)?\s*(?:name)?\s*[:\-–—]\s*(.+)$/im,
      /^\s*account\s*name\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-prospect', prospect);

    var facility = lineVal(raw, [
      /^\s*facility\s*(?:name)?\s*[:\-–—]\s*(.+)$/im,
      /^\s*(?:property|building)\s*name\s*[:\-–—]\s*(.+)$/im,
      /^\s*site\s*name\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-facility', facility);

    var contact = lineVal(raw, [
      /^\s*(?:facility\s+)?contact\s*[:\-–—]\s*(.+)$/im,
      /^\s*(?:fm|facility\s+manager)\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-contact', contact);

    var sqft = parseSqftLoose(raw);
    if (sqft) take('bd-sqft', sqft);

    var loc = parseCityState(raw);
    take('bd-city', loc.city);
    take('bd-state', loc.state);

    var freq = mapFrequency(lineVal(raw, [
      /^\s*(?:service\s+)?(?:schedule|frequency)\s*[:\-–—]\s*(.+)$/im,
      /^\s*days?\s*(?:per\s*week)?\s*[:\-–—]\s*(.+)$/im
    ]) || (/\b(5\s*days?\/?week|mon.?fri|7\s*days?|3\s*days?\/?week|weekly|biweekly|monthly|one-?time)\b/i.exec(raw) || [])[0]);
    if (freq) take('bd-frequency', freq);

    var building = mapBuilding(lineVal(raw, [
      /^\s*(?:building|facility)\s*type\s*[:\-–—]\s*(.+)$/im,
      /^\s*vertical\s*[:\-–—]\s*(.+)$/im,
      /^\s*specialty\s*[:\-–—]\s*(.+)$/im
    ]) || raw);
    if (building) take('bd-building', building);

    var floors = parseFloorMix(raw);
    if (floors) {
      take('bd-hard-pct', floors.hard);
      take('bd-carpet-pct', floors.carpet);
    } else {
      fields['bd-hard-pct'] = '70';
      fields['bd-carpet-pct'] = '30';
      defaultsApplied.push('floor_mix');
    }

    var fixtures = parseNumber(lineVal(raw, [
      /^\s*(?:restroom\s+)?fixtures?\s*[:\-–—]\s*(.+)$/im,
      /^\s*(?:toilet|restroom)\s*count\s*[:\-–—]\s*(.+)$/im
    ]));
    if (fixtures != null) {
      take('bd-fixtures', Math.round(fixtures));
    } else if (sqft && sqft >= 100) {
      var est = Math.max(2, Math.round((sqft / 2500) * 2));
      fields['bd-fixtures'] = String(est);
      defaultsApplied.push('fixtures');
      if (extracted.indexOf('bd-fixtures') < 0) extracted.push('bd-fixtures');
    }

    var years = parseNumber(lineVal(raw, [
      /^\s*years?\s*(?:in\s*)?business\s*[:\-–—]\s*(.+)$/im
    ]));
    if (years != null) take('bd-years', Math.round(years));

    var glOcc = lineVal(raw, [
      /^\s*gl\s*(?:per\s*)?occurrence\s*[:\-–—]\s*(.+)$/im,
      /^\s*general\s*liability\s*(?:per\s*occurrence)?\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-gl-occurrence', glOcc);
    var glAgg = lineVal(raw, [
      /^\s*gl\s*aggregate\s*[:\-–—]\s*(.+)$/im
    ]);
    take('bd-gl-aggregate', glAgg);

    var creds = parseCredentials(raw);
    fields._credentials = creds;
    if (creds.licensed || creds.bonded || creds.insured || creds.certs.length) {
      extracted.push('bd-credentials');
    }

    var notes = lineVal(raw, [
      /^\s*notes?\s*[:\-–—]\s*(.+)$/im,
      /^\s*additional\s*(?:details|notes|scope)\s*[:\-–—]\s*(.+)$/im
    ]);
    if (notes) take('bd-notes', notes);

    var missingCritical = CRITICAL.filter(function (k) {
      return !fields[k] || !String(fields[k]).trim();
    });

    return {
      fields: fields,
      extracted: extracted,
      missingCritical: missingCritical,
      defaultsApplied: defaultsApplied,
      leftovers: raw.trim(),
      extractedCount: extracted.length
    };
  }

  function setInput(id, value) {
    var el = document.getElementById(id);
    if (!el || value == null || value === '') return false;
    el.value = String(value);
    el.classList.remove('is-sample', 'd4-f-missing');
    try {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
    return true;
  }

  function applyToForm(result) {
    if (!result || !result.fields) return;
    var f = result.fields;
    setInput('opf_bd-company', f['bd-company']);
    setInput('opf_bd-prospect', f['bd-prospect']);
    setInput('opf_bd-facility', f['bd-facility']);
    setInput('opf_bd-contact', f['bd-contact']);
    setInput('opf_bd-sqft', f['bd-sqft']);
    setInput('opf_bd-city', f['bd-city']);
    setInput('opf_bd-state', f['bd-state']);
    setInput('opf_bd-years', f['bd-years']);
    setInput('opf_bd-hard-pct', f['bd-hard-pct']);
    setInput('opf_bd-carpet-pct', f['bd-carpet-pct']);
    setInput('opf_bd-fixtures', f['bd-fixtures']);
    setInput('opf_bd-gl-occurrence', f['bd-gl-occurrence']);
    setInput('opf_bd-gl-aggregate', f['bd-gl-aggregate']);
    if (f['bd-frequency']) setInput('opf_bd-frequency', f['bd-frequency']);
    if (f['bd-building']) {
      setInput('opf_bd-building', f['bd-building']);
      setInput('opf_bd-vertical', f['bd-building'] === 'retail' ? 'commercial' : f['bd-building']);
    }
    var creds = f._credentials;
    if (creds) {
      var map = {
        licensed: 'opf_bd-credentials__licensed',
        bonded: 'opf_bd-credentials__bonded',
        insured: 'opf_bd-credentials__insured'
      };
      Object.keys(map).forEach(function (k) {
        var el = document.getElementById(map[k]);
        if (el) el.checked = !!creds[k];
      });
      (creds.certs || []).forEach(function (c) {
        var el = document.getElementById('opf_bd-credentials__' + String(c).toLowerCase());
        if (el) el.checked = true;
      });
    }
    // Keep leftover paste available after switching to form (notes + hidden stash)
    if (result.leftovers) {
      var notesEl = document.getElementById('opf_bd-notes');
      if (notesEl && !String(notesEl.value || '').trim()) {
        // Prefer labeled Notes line if extracted; else stash full paste for rfp_text path
        if (f['bd-notes']) setInput('opf_bd-notes', f['bd-notes']);
      }
      var stash = document.getElementById('opf_bd-paste-stash');
      if (stash) stash.value = result.leftovers;
    }
  }

  function clearMissingHighlights() {
    document.querySelectorAll('.d4-f-missing').forEach(function (el) {
      el.classList.remove('d4-f-missing');
    });
  }

  function highlightMissing(keys) {
    clearMissingHighlights();
    var first = null;
    (keys || []).forEach(function (key) {
      var el = document.getElementById('opf_' + key);
      if (!el) return;
      el.classList.add('d4-f-missing');
      if (!first) first = el;
    });
    return first;
  }

  function labelFor(key) {
    return FIELD_LABELS[key] || key.replace(/^bd-/, '').replace(/-/g, ' ');
  }

  function humanizeApiError(msg) {
    var raw = String(msg == null ? '' : msg);
    if (!raw.trim()) return 'Something went wrong. Please check your inputs and try again.';

    var missing = [];
    var schemaRe = /([a-z0-9_.]+)\s*\((?:string|number|integer|boolean|array|object)\)\s+is\s+required/gi;
    var m;
    while ((m = schemaRe.exec(raw))) {
      var path = m[1];
      var leaf = path.split('.').pop();
      if (leaf === 'company_name') missing.push('Company Name');
      else if (leaf === 'sqft') missing.push('Square Footage');
      else if (leaf === 'city') missing.push('City');
      else if (leaf === 'state') missing.push('State');
      else missing.push(leaf.replace(/_/g, ' '));
    }

    if (/company[_\s]?name/i.test(raw) && missing.indexOf('Company Name') < 0) {
      missing.push('Company Name');
    }
    if (/\bsqft\b|square\s*footage/i.test(raw) && /required|enter/i.test(raw) && missing.indexOf('Square Footage') < 0) {
      missing.push('Square Footage');
    }
    if (/facility city|\bcity\b/i.test(raw) && /required|enter/i.test(raw) && missing.indexOf('City') < 0) {
      missing.push('City');
    }
    if (/facility state|\bstate\b/i.test(raw) && /required|enter|2-letter/i.test(raw) && missing.indexOf('State') < 0) {
      missing.push('State');
    }
    if (/city and state/i.test(raw)) {
      if (missing.indexOf('City') < 0) missing.push('City');
      if (missing.indexOf('State') < 0) missing.push('State');
    }

    // Strip developer-looking paths from leftover text
    var cleaned = raw
      .replace(/[a-z0-9_]+\.[a-z0-9_.]+\s*\((?:string|number|integer|boolean|array|object)\)\s+is\s+required/gi, '')
      .replace(/\bbusiness_profile\.[a-z0-9_]+\b/gi, '')
      .replace(/\bdeal_details\.[a-z0-9_]+\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (missing.length) {
      return {
        title: 'A few details are still needed',
        message: 'Please fill in: ' + missing.join(', ') + '.',
        missing: missing,
        missingKeys: missing.map(function (lab) {
          if (lab === 'Company Name') return 'bd-company';
          if (lab === 'Square Footage') return 'bd-sqft';
          if (lab === 'City') return 'bd-city';
          if (lab === 'State') return 'bd-state';
          return '';
        }).filter(Boolean),
        action: 'fill_missing'
      };
    }

    if (/enter your company name/i.test(cleaned) || /company name/i.test(cleaned) && /paste/i.test(cleaned)) {
      return {
        title: 'Company name needed',
        message: 'Add your company name so we can put it on the proposal cover.',
        missing: ['Company Name'],
        missingKeys: ['bd-company'],
        action: 'fill_missing'
      };
    }
    if (/square footage|sqft/i.test(cleaned) && /enter|required/i.test(cleaned)) {
      return {
        title: 'Square footage needed',
        message: 'Add the facility square footage (100+ sq ft) so we can price the bid.',
        missing: ['Square Footage'],
        missingKeys: ['bd-sqft'],
        action: 'fill_missing'
      };
    }
    if (/city and state|bls-anchored/i.test(cleaned)) {
      return {
        title: 'City and state needed',
        message: 'Add the facility city and state so we can anchor pricing to local wage data.',
        missing: ['City', 'State'],
        missingKeys: ['bd-city', 'bd-state'],
        action: 'fill_missing'
      };
    }
    if (/facility city|\bcity\b/i.test(cleaned) && /enter|required/i.test(cleaned)) {
      return {
        title: 'City needed',
        message: 'Add the facility city for BLS-anchored pricing.',
        missing: ['City'],
        missingKeys: ['bd-city'],
        action: 'fill_missing'
      };
    }
    if (/facility state|\bstate\b/i.test(cleaned) && /enter|required|2-letter/i.test(cleaned)) {
      return {
        title: 'State needed',
        message: 'Add the facility state (2-letter code, e.g. FL).',
        missing: ['State'],
        missingKeys: ['bd-state'],
        action: 'fill_missing'
      };
    }

    return {
      title: 'Something went wrong',
      message: cleaned || 'Please check your inputs and try again.',
      missing: [],
      missingKeys: [],
      action: 'retry'
    };
  }

  function buildImportBanner(result) {
    var n = result.extractedCount || 0;
    var missLabs = (result.missingCritical || []).map(labelFor);
    var defaults = [];
    if ((result.defaultsApplied || []).indexOf('floor_mix') >= 0) {
      defaults.push('Default floor mix applied (70% hard / 30% carpet)');
    }
    if ((result.defaultsApplied || []).indexOf('fixtures') >= 0) {
      defaults.push('Estimated restroom fixtures from square footage');
    }
    var html = '<div class="bd-import-banner" role="status">';
    if (n > 0) {
      html += '<p class="bd-import-banner__title">We extracted ' + n + ' detail' + (n === 1 ? '' : 's') + ' from your notes.</p>';
    } else {
      html += '<p class="bd-import-banner__title">A few details are still needed</p>';
    }
    if (missLabs.length) {
      html += '<p class="bd-import-banner__body">Please fill in <strong>' + missLabs.join(' and ') + '</strong> to generate.</p>';
    } else {
      html += '<p class="bd-import-banner__body">Review the prefilled fields, then draft your bid.</p>';
    }
    if (defaults.length) {
      html += '<p class="bd-import-banner__hint">' + defaults.join(' · ') + '</p>';
    }
    if (missLabs.length) {
      html += '<button type="button" class="bd-import-banner__cta" id="bdImportFocusMissing">Fill in Missing Fields →</button>';
    }
    html += '</div>';
    return html;
  }

  w.OporaBidPasteImport = {
    SAMPLE_TEMPLATE: SAMPLE_TEMPLATE,
    CRITICAL: CRITICAL,
    FIELD_LABELS: FIELD_LABELS,
    parse: parse,
    applyToForm: applyToForm,
    highlightMissing: highlightMissing,
    clearMissingHighlights: clearMissingHighlights,
    labelFor: labelFor,
    humanizeApiError: humanizeApiError,
    buildImportBanner: buildImportBanner
  };
})(window);
